import React, { useContext } from 'react';
import { Container, Row, Col, Alert } from 'reactstrap';
import Vaccinations from '../vaccinations/Vaccinations';
import VacForm from '../vaccinations/VacForm';
import VacFilter from '../vaccinations/VacFilter';
import AuthContext from '../../context/auth/authContext';

const DEMO_EMAIL = 'demo@vactrac.local';

const MyVac = () => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const isDemo = user && user.email === DEMO_EMAIL;

  return (
    <Container fluid className="myvac">
      {isDemo && (
        <Row>
          <Col lg="12">
            <Alert color="info">
              Demo environment. Fictional sample data only. Do not enter personal health information.
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg="12">
          <span><h2>My VacTrac Records</h2></span>
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <VacForm />
        </Col>
        <Col lg="auto">
          <VacFilter />
          <Vaccinations />
        </Col>
      </Row>
    </Container >
  )
}
export default MyVac;
